import React from 'react'

import anychart from 'anychart'
import { injectIntl } from 'react-intl'
import uuid, { chartColor, setMaxAndInterval } from '../../../services/ChartService'

class ColumnChart extends React.Component {
  constructor (props) {
    super(props)
    anychart.licenseKey('mailup.com-761e5414-30aca999')
    anychart.theme({ chart: { credits: { enabled: false } } })
    this.id = uuid()
    this.containerElement = React.createRef()
  }

  render () {
    return (
      <div id={this.id} style={this.props.style} ref={this.containerElement} />
    )
  }

  componentDidMount () {
    const stage = anychart.graphics.create(this.id)
    const chart = anychart.column()

    chart.credits().enabled(false)
    chart.animation(true)

    chart.column(this.props.data)

    chart.yGrid().enabled(true)
    chart.yGrid().stroke({
      dash: '7',
      color: chartColor.Axis
    })

    chart.yAxis().stroke({
      color: '#FFFFFF'
    })
    chart.yAxis().labels().format(({ value }) => this.props.intl.formatNumber(value))

    const xAxis1 = chart.xAxis().stroke('2.5 ' + chartColor.Axis)
    xAxis1.labels(false)
    xAxis1.staggerLines(0)
    const max = Math.max.apply(Math, this.props.data.map(function (o) { return o.value }))

    var yScale = chart.yScale()
    yScale.minimum(0)
    const maxAndInterval = setMaxAndInterval(max)
    yScale.maximum(maxAndInterval.maxValue)
    yScale.ticks().interval(maxAndInterval.interval)

    // tooltips
    chart.tooltip().positionMode('point')
    chart.tooltip().useHtml(true)
    chart.tooltip().format(({ value }) => this.props.intl.formatNumber(value))
    // chart.tooltip().offsetX(-10)
    // chart.tooltip().offsetY(-50)

    // interactivity settings
    chart.interactivity().hoverMode('by-x')
    chart.interactivity().selectionMode('none')

    chart.xAxis().ticks().stroke({ thickness: 0 })

    chart.legend().fontFamily('arial, sans-serif')
    chart.xAxis().labels().fontFamily('arial, sans-serif')
    chart.yAxis().labels().fontFamily('arial, sans-serif')

    // set container id for the chart
    chart.container('container')

    // initiate chart drawing
    chart.container(stage).draw()
    //
    if (this.containerElement && this.containerElement.current) {
      const svgElement = this.containerElement.current.querySelector('svg')
      if(svgElement !== null)
      {
        svgElement.setAttribute('viewBox', `0 0 ${svgElement.clientWidth} ${svgElement.clientHeight}`)
      }
      
    }
  }
}

export default injectIntl(ColumnChart)
